import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllActivitiesByGroup } from 'domain/usecases';

export class RemoteGetAllActivitiesByGroup implements GetAllActivitiesByGroup {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetAllActivitiesByGroup.Result>,
  ) {}

  async execute(
    params: GetAllActivitiesByGroup.Params,
  ): Promise<GetAllActivitiesByGroup.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(this.url, {
        length: params.length,
        starts: params.starts,
        ends: params.ends,
        entity: params.entity,
        course: params.course,
        semester: params.semester,
        curricularUnit: params.curricularUnit,
        groups: params.group,
      }),
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
